import { render } from "./vegas25.vue?vue&type=template&id=d2c38b9a"
import script from "./vegas25.vue?vue&type=script&lang=js"
export * from "./vegas25.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__